import styled from "styled-components"
import HR from "@irati/ui/src/Layout/Hr"
import {Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"

interface Props {
  selected?: boolean
}

export const StyledDiv = styled.div`
  width: 500px;
  text-align: center;
`

export const StyledHR = styled(HR)`
  margin: 4px 0 30px;
`

export const StyledLabel = styled(Label)<Props>`
  padding: 0 8px 4px;
  margin: 0 3px;
  font-weight: ${(props) => (props.selected ? "bold" : "normal")};
  ${(props) => (props.selected ? `border-bottom: 5px solid ${theme.colors.brand.default};` : "")}
  cursor: pointer;
  text-transform: uppercase;
`
